import { render, staticRenderFns } from "./ChallengeItem.vue?vue&type=template&id=2654f982&scoped=true"
import script from "./ChallengeItem.vue?vue&type=script&lang=js"
export * from "./ChallengeItem.vue?vue&type=script&lang=js"
import style0 from "./ChallengeItem.vue?vue&type=style&index=0&id=2654f982&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2654f982",
  null
  
)

export default component.exports